import { Box, CircularProgress, Typography } from '@mui/material';

function BaseLoader({ text = 'Loading...' }) {
  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        gap: 2 // provides spacing between CircularProgress and Typography
      }}
    >
      <CircularProgress />
      <Typography variant="h6" color="textSecondary">
        {text}
      </Typography>
    </Box>
  );
}

export default BaseLoader;
